import { useRef } from "react";
import { Button, Space } from "antd";
import { PaperClipOutlined, CloseOutlined } from "@ant-design/icons";
import pdfIcon from "../../assets/svgs/pdf_svg_icon.svg";
import { useNotification } from "../../contexts/NotificationProvider";

const CommonAttachment = ({ file, onUpload, onRemove }) => {
  const fileInputRef = useRef(null);

  const notify = useNotification();

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile.type !== "application/pdf") {
        notify({
          type: "error",
          message: "Error",
          description: "Only PDF files are allowed.",
        });
        e.target.value = null;
        return;
      }
      onUpload(selectedFile);
    }
  };

  const handleRemoveAttachment = () => {
    onRemove();
    fileInputRef.current.value = null;
  };

  return (
    <div
      style={{
        borderRadius: "8px",
        display: "inline-block",
        width: "100%",
        marginTop: "50px",
      }}
    >
      <input
        type="file"
        accept=".pdf"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      <Space size="middle" align="center">
        <Button
          type="link"
          icon={<PaperClipOutlined />}
          onClick={handleButtonClick}
          style={{
            padding: 0,
            color: "#212180",
            textDecoration: "underline",
            fontFamily: "Poppins",
            fontWeight: "500",
            fontStyle: "Medium",
            fontSize: "16px",
            lineHeight: "20px",
            textAlign: "center",
          }}
        >
          Add Attachment
        </Button>

        {file && (
          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              background: "#fafbff",
              borderRadius: "6px",
              padding: "10px",
            }}
          >
            <img src={pdfIcon} alt="pdf icon" />

            <div style={{ display: "flex", flexDirection: "column" }}>
              <span
                style={{
                  fontSize: "14px",
                  color: "#333",
                  marginRight: "8px",
                }}
              >
                {file.name.replace(/\.[^/.]+$/, "")}
              </span>

              <span
                style={{
                  fontSize: "12px",
                  color: "#999",
                }}
              >
                {(file.size / 1024).toFixed(1)} kb
              </span>
            </div>

            <Button
              type="text"
              size="small"
              icon={<CloseOutlined style={{ width: "11px" }} />}
              onClick={handleRemoveAttachment}
              style={{
                position: "absolute",
                right: "-10px",
                top: "9%",
                transform: "translateY(-50%)",
                color: "#FF3333",
                fontSize: "12px",
                width: "21px",
                height: "21px",
                minWidth: "20px",
                padding: 0,
                backgroundColor: "#FF000033",
                borderRadius: "50%",
              }}
            />
          </div>
        )}
      </Space>
    </div>
  );
};

export default CommonAttachment;
